<template>
  <v-container
    fill-height
    fluid
  >
    <v-layout
      v-if="!$apollo.loading && getWhiteLabel"
      wrap
    >
      <v-flex
        md5
        xs12
        mb-0
        mt-0
        pb-0
      >
        <h2>{{ $t('invoices.invoices') }}</h2>
      </v-flex>
      <v-flex
        md3
        xs12
        mb-0
        mt-0
        :class="!$vuetify.breakpoint.xs ? 'pt-5 text-right': 'pt-0'"
        pb-0
        text-right
      >
        <v-text-field
          v-model.trim="search"
          name="search"
          max-length="100"
          style="width:220px"
          prepend-inner-icon="mdi-text-box-search-outline"
          @change="reload()"
        >
          <template v-slot:append>
            <v-icon
              v-if="search"
              style="cursor:pointer"
              @click="search = null;reload()"
            >
              mdi-close
            </v-icon>
          </template>
        </v-text-field>
      </v-flex>
      <v-flex
        md4
        xs12
        mb-0
        :class="!$vuetify.breakpoint.xs ? 'pt-11 text-right': 'pb-5'"
        pb-0
      >
        <v-menu
          style="display:inline;"
          offset-y
          right
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-btn
              class="mr-2"
              style="margin-top: -0.35rem;"
              :disabled="$apollo.loading"
              outlined 
              small
              text
              v-on="on"
            >
              {{ $t('invoices.'+ status) }}
            </v-btn>
          </template>
          <v-sheet dense>
            <v-list-item
              v-for="(s, i) in ['all', 'paid', 'unpaid']"
              :key="i"
              @click="status = s;reload()"
            >
              <v-list-item-title>{{ $t('invoices.'+ s) }}</v-list-item-title>
            </v-list-item>
          </v-sheet>
        </v-menu>
        <v-btn
          style="display:inline;margin-top:-6px;"
          small
          class="primary"
          @click="createInvoiceDialog = true"
        >
          {{ $t('globals.createButton') }}
        </v-btn>
      </v-flex>

      <v-flex
        v-if="!$apollo.loading"
      >
        <v-card>
          <v-flex v-if="whiteLabelInvoices && !_.isEmpty(whiteLabelInvoices.data)">
            <v-data-table  
              v-if="whiteLabelInvoices.data.length > 0" 
              :class="$vuetify.breakpoint.xs ? '' : 'text-no-wrap'" 
              :headers="headers"
              :footer-props="{
                'items-per-page-options': [10, 15, 25, 50, 100, 200]
              }"
              :locale="$i18n.locale"
              :items="whiteLabelInvoices.data"
              :items-per-page="whiteLabelInvoices.per_page"
              :page="whiteLabelInvoices.current_page"
              :server-items-length="whiteLabelInvoices.total"
              :hide-default-footer="_.isEmpty(whiteLabelInvoices.data)"
              @update:items-per-page="reload($event, 'count')"
              @update:page="reload($event, 'page')"
            >
              <template v-slot:item.id="{ item }">
                <router-link :to="`/invoice/${item.id}`">
                  <b>{{ item.id }}</b>
                </router-link>
              </template>
              <template v-slot:item.user="{ item }">
                <v-layout
                  wrap
                >
                  <v-flex
                    md3
                    xs4
                    mt-4
                    mb-1
                  >
                    <v-avatar
                      v-if="item.user.avatar != null"
                      style="cursor: pointer;"
                      :tile="false"
                      :size="30"
                    >
                      <v-img
                        :src="item.user.avatar"
                        :lazy-src="item.user.avatar"
                        max-height="30"
                        contain
                      />
                    </v-avatar>
                    <v-avatar
                      v-else
                      style="cursor: pointer;"
                      :tile="false"
                      :size="30"
                      :color="$vuetify.theme.dark ? $vuetify.theme.themes.dark.background : $vuetify.theme.themes.light.background"
                    >
                      <strong>
                        <a>{{ item.user.name | uppercase | substring(0,2) }}</a>
                      </strong>
                    </v-avatar>
                  </v-flex>
                  <v-flex
                    md9
                    xs8
                    mt-2
                    mb-2
                  >
                    <small><b>{{ item.user.name }}</b><br>
                      {{ item.user.email }}</small>
                  </v-flex>
                </v-layout>
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ item.created_at | moment('L') }}
              </template>
              <template v-slot:item.total="{ item }">
                <b>{{ item.total }} {{ item.currency }}</b>
              </template>
              <template v-slot:item.status="{ item }">
                <b 
                  :class="colorStatus(item.status)"
                >
                  {{ $t('invoices.'+item.status) }} 
                </b>
                <small v-if="item.status === 'unpaid'"><br>
                  {{ $t('invoices.due') }}:<b> {{ item.due_date | moment('L') }}</b>
                </small>
                <small v-if="item.status === 'refunded'"><br>
                  {{ $t('invoices.refunded') }}:<b> {{ item.updated_at | moment('L') }}</b>
                </small>
              </template>
           
              <template v-slot:item.actions="{ item }">
                <v-menu
                  offset-y
                  left
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      outlined 
                      small
                      text
                      v-on="on"
                    >
                      {{ $t('globals.manageButton') }}
                    </v-btn>
                  </template>
                  <v-sheet dense>
                    <v-list-item
                      @click="$router.push(`/invoice/${item.id}`)"
                    >
                      <v-list-item-title>{{ $t('invoices.viewButton') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="item.status === 'paid'"
                      @click="refundInvoice(item)"
                    >
                      <v-list-item-title>{{ $t('invoices.refund') }}</v-list-item-title>
                    </v-list-item>
                    <template v-if="item.status === 'unpaid'">
                      <v-list-item
                        @click="payInvoice(item)"
                      >
                        <v-list-item-title>{{ $t('invoices.pay') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="confirmDelete(item)"
                      >
                        <v-list-item-title>{{ $t('globals.deleteButton') }}</v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-sheet>
                </v-menu>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex
            v-if="whiteLabelInvoices && _.isEmpty(whiteLabelInvoices.data) && !loading"
            mt-4 
            class="not-found"
          >
            <v-icon>mdi-ghost</v-icon>
            <p>{{ $t('invoices.notFound') }}</p>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="!getWhiteLabel"
      wrap
      justify-center
    >
      <helper-start-white-label />
    </v-layout>
    <create-invoice-dialog 
      v-if="createInvoiceDialog"
      :whitelabel-uuid="params.whitelabel_uuid"
      :show-dialog="createInvoiceDialog"
      @closeCreateInvoiceDialog="closeCreateInvoiceDialog"
    />
    <helper-confirm-dialog
      v-if="confirmDialog"
      :show-dialog="confirmDialog"
      :text="$t('invoices.reallyDelete', {id: selectedInvoice.id})"
      @closeConfirmDialog="closeConfirmDialog"
    />
    <pay-invoice-dialog
      v-if="payInvoiceDialog"
      :show-dialog="payInvoiceDialog"
      :invoice="selectedInvoice"
      @closePayInvoiceDialog="closePayInvoiceDialog"
    />
    <refund-invoice-dialog
      v-if="refundInvoiceDialog"
      :show-dialog="refundInvoiceDialog"
      :invoice="selectedInvoice"
      :white-label-uuid="getWhiteLabel.uuid"
      @closeRefundInvoiceDialog="closeRefundInvoiceDialog"
    />
  </v-container>
</template>

<script>

import WHITELABEL_INVOICES_QUERY from '@/graphql/queries/WhiteLabelInvoices.gql';
import DELETE_INVOICE_MUTATION  from '@/graphql/mutations/DeleteInvoice.gql'
import CreateInvoiceDialog from "@/views/Invoices/CreateInvoiceDialog.vue";
import PayInvoiceDialog from "@/views/Invoices/PayInvoiceDialog.vue";

import { mapGetters } from 'vuex'
import RefundInvoiceDialog from "@/views/Invoices/RefundInvoiceDialog.vue";

export default {
  name: 'WhiteLabelInvoices',
  components: {
    RefundInvoiceDialog,
    CreateInvoiceDialog,
    PayInvoiceDialog
  },
  data() {
    return {
      selectedInvoice: null,
      payInvoiceDialog: false,
      refundInvoiceDialog: false,
      confirmDialog: false,
      createInvoiceDialog: false,
      loading: false,
      search: null,
      status: "all",
      params: {
        whitelabel_uuid: null,
        page: 1,
        count: 25
      },
      headers: [
        {
          sortable: false,
          text: this.$t('invoices.invoice'),
          value: 'id'
        },
        {
          sortable: false,
          text: this.$t('invoices.user'),
          value: 'user',
        },
        {
          sortable: false,
          text: this.$t('invoices.sum'),
          value: 'total'
        },
        {
          sortable: false,
          text: this.$t('invoices.created'),
          value: 'created_at',
        },
        {
          sortable: false,
          text: this.$t('invoices.status'),
          value: 'status'
        },
        {
          sortable: false,
          text: '',
          value: 'actions',
        },
      ]
    }
    
  },
  computed: {
    ...mapGetters('user', ['getUser']),
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
  },
  watch: {
    getWhiteLabel(){
       this.reload(null, null, this.getWhiteLabel.uuid)
    }
  },
  mounted() {
    if ( this.getWhiteLabel) {
      this.params.whitelabel_uuid = this.getWhiteLabel.uuid
    }
  },
  methods: {
    confirmDelete(item) {
      this.confirmDialog = true
      this.selectedInvoice = item
    },
    payInvoice(item) {
      this.selectedInvoice = item
      this.payInvoiceDialog = true
    },
    refundInvoice(item) {
      this.selectedInvoice = item
      this.refundInvoiceDialog = true
    },
    closePayInvoiceDialog(refresh) {
      this.payInvoiceDialog = false
      if (refresh) {
          this.$apollo.queries.whiteLabelInvoices.refresh();
      }
    },
    closeRefundInvoiceDialog(refresh) {
      this.refundInvoiceDialog = false
      if (refresh) {
          this.$apollo.queries.whiteLabelInvoices.refresh();
      }
    },
    closeCreateInvoiceDialog(val) {
      this.createInvoiceDialog = val
    },
    closeConfirmDialog(confirmed) {
      this.confirmDialog = false
      if (confirmed) {
        this.deleteInvoice()
      }
    },
    deleteInvoice() {
      this.$apollo
      .mutate({
        mutation: DELETE_INVOICE_MUTATION,
        variables: {
          invoice_id: this.selectedInvoice.id,
        }
      })
      .then(data => {
        this.$store.commit('app/setNotifier', this.$t('globals.success'));
        this.$apollo.queries.whiteLabelInvoices.refetch()
      })
      .catch(error => {
        this.errorHandler(error);
        this.loading = false;
      });
    },
    reload(value = null, from = null, uuid = null) {

      if (value && from) {
        this.params[from] = value
      }
      if (uuid) {
        this.params.whitelabel_uuid = uuid
      }

      if (this.search) {
        if (this.search.length < 2) {
          return
        }
        this.params.search = this.search
        
      } else {
        delete(this.params.search)
      }

      if (this.status === "all") {
          delete(this.params.status)
      } else {
         this.params.status = this.status
      }

      this.$apollo.queries.whiteLabelInvoices.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return fetchMoreResult
        },
      })
    },
  },
  apollo: {
    whiteLabelInvoices: {
      query: WHITELABEL_INVOICES_QUERY,
      fetchPolicy: 'network-only',
      variables() {
        return this.params
      },
      skip() {
        return !this.params.whitelabel_uuid
      }
    },
  }
}
</script>

<style lang="scss">


</style>
